import Base from '../Base';

export default class Simulator extends Base {
    static url = '/api/simulator';
}
